import { Injectable } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { MediaObjectModel } from '../../libs/component-lib/components/media-object/media-object.model';
import { FulfilmentStatusConstant } from '../../libs/component-lib/constants/fulfilment-status.constant';
import { EvsbThankYouMailModel, EvsbThankYouMailModelItem } from './evsb-thank-you-mail.model';

@Injectable()
export class EvsbThankYouMailMapper {
  public map(): EvsbThankYouMailModel {
    return {
      title: marker('modules.evcSmallBiz.thankYouMail.title'),
      alert: this.getAlert(),
      items: this.getItems(),
    };
  }

  private getAlert(): MediaObjectModel {
    return {
      src: './assets/evc/img/contact.svg',
      text: marker('modules.evcSmallBiz.thankYouMail.alert.text'),
    };
  }

  private getItems(): EvsbThankYouMailModelItem[] {
    const items = [] as EvsbThankYouMailModelItem[];

    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouMail.fulfilment.1.title`),
      status: FulfilmentStatusConstant.completed,
    });
    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouMail.fulfilment.2.title`),
      text: marker(`modules.evcSmallBiz.thankYouMail.fulfilment.2.text`),
      status: FulfilmentStatusConstant.checkMailbox,
    });
    items.push({
      completed: true,
      title: marker(`modules.evcSmallBiz.thankYouMail.fulfilment.3.title`),
      text: marker(`modules.evcSmallBiz.thankYouMail.fulfilment.3.text`),
      status: FulfilmentStatusConstant.optional,
    });

    return items;
  }
}
